import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

export function CardGrid({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)", xl: "repeat(3, 1fr)" }, mb: 2 }}>
      {children}
    </Box>
  );
}

export default function Card({ title, wide, children }: { title: string; wide?: boolean; children: ReactNode }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, gridColumn: wide ? "1 / -1" : undefined, minWidth: 0 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>{title}</Typography>
      {children}
    </Paper>
  );
}

export function Empty() {
  return <Typography color="text.secondary" sx={{ py: 3 }}>No activity in this range.</Typography>;
}
